import React from "react";
import { DatePicker, Form, Input, Select } from "antd";
import moment from "moment";
import { useSelector } from "react-redux";
import ImageComponent from "./useAttachments";
import { requiredFeilds, getErrorText } from "../utils";

const { Option } = Select;
const { TextArea } = Input;

const EditableCell = ({
  cell,
  expandedRowKeys,
  setExpandedRowKeys,
  images,
  setImages,
  attachPopupVisible,
  setAttachPopupVisible,
  currentUpdateObj,
  values,
  handleChangeDocType,
  getColumnName,
  isRevisionUpdateCase,
  dueDateRequired,
  type,
}) => {
  const {
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  } = cell;
  const shouldDisabled = values?.material_type_id > 0 ? false : true;

  const { allTemplates } = useSelector((state) => state.materialTemplatesReducer);
  const { allMaterialTypes } = useSelector((state) => state.materialTypesReducer);
  const { allBoltTypes } = useSelector((state) => state.materialTypesReducer);

  let inputNode;

  let classname = `${isRevisionUpdateCase ? "ims-doc-readonly-input" : ""}`;

  let isRequired = [...requiredFeilds];
  dueDateRequired && isRequired.push("document_due_date");
  
  // Use the type prop passed from parent component  
  if (type === "material") {
    switch (dataIndex) {
      case "area":
        inputNode = (
          <Input
            placeholder={getColumnName(0)}
            size="small"
            classname={classname}
            readOnly={isRevisionUpdateCase}
          />
        );
        break;
      case "assemblyNo":
        inputNode = (
          <Input
            placeholder={getColumnName(1)}
            size="small"
            classname={classname}
            readOnly={isRevisionUpdateCase}
          />
        );
        break;
      case "revision":
        inputNode = (
          <Input
            placeholder={getColumnName(2)}
            size="small"
            classname={classname}
            readOnly={isRevisionUpdateCase}
          />
        );
        break;
      case "uniqueId":
        inputNode = (
          <Input
            placeholder={getColumnName(3)}
            size="small"
            classname={classname}
            readOnly={isRevisionUpdateCase}
          />
        );
        break;
      case "qty":
        inputNode = (
          <Input
            placeholder={getColumnName(4)}
            size="small"
            classname={classname}
            readOnly={isRevisionUpdateCase}
          />
        );
        break;
      case "materialTypeId":
        inputNode = (
          <Select
            showSearch
            className={`activities-selector ${classname}`}
            style={{ width: "120px" }}
            getPopupContainer={() =>
              document.getElementsByClassName(
                "ant-layout-content layout-content site-layout-background custom-textarea"
              )[0]
            }
            dropdownClassName="select-dropdown-custom"
            placeholder="Material Type"
            size="small"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {allMaterialTypes.map(({ id, materialType }) => (
              <Option key={id} value={id}>
                {materialType}
              </Option>
            ))}
          </Select>
        );
        break;
      default:
        break;
    }
  } else if (type === "bolts") {
    switch (dataIndex) {
      case "area":
        inputNode = (
          <Input
            placeholder={getColumnName(0)}
            size="small"
            classname={classname}
            readOnly={isRevisionUpdateCase}
          />
        );
        break;
      case "revision":
        inputNode = (
          <Input
            placeholder={getColumnName(2)}
            size="small"
            classname={classname}
            readOnly={isRevisionUpdateCase}
          />
        );
        break;
      case "qty":
        inputNode = (
          <Input
            placeholder={getColumnName(4)}
            size="small"
            classname={classname}
            readOnly={isRevisionUpdateCase}
          />
        );
        break;
      case "materialTypeId":
        inputNode = (
          <Select
            showSearch
            className={`activities-selector ${classname}`}
            style={{ width: "120px" }}
            getPopupContainer={() =>
              document.getElementsByClassName(
                "ant-layout-content layout-content site-layout-background custom-textarea"
              )[0]
            }
            dropdownClassName="select-dropdown-custom"
            placeholder="Material Type"
            size="small"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {allBoltTypes.map(({ id, materialType }) => (
              <Option key={id} value={id}>
                {materialType}
              </Option>
            ))}
          </Select>
        );
        break;
      default:
        break;
    }
  }
  return (
    <td {...restProps}>
      {editing ? (
        dataIndex === "stop_time" ? (
          <Form.Item
            name={dataIndex}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: ``,
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  let startTime = getFieldValue("start_time");
                  const isBefore = moment(startTime).isBefore(
                    value,
                    "milliseconds"
                  );
                  if (isBefore) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(""));
                },
              }),
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          <Form.Item
            className={`ims-doc-first-level ${classname}`}
            name={dataIndex}
            style={{ margin: 0 }}
            rules={[
              {
                required: isRequired.includes(dataIndex),
                message: getErrorText(dataIndex),
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        )
      ) : (
        children
      )}
    </td>
  );
};

export default EditableCell;
